import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MemberService } from '../rest/api/member.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class CompanyResolverService implements Resolve<any> {
  accessToken: any;
  constructor(
    private memberService: MemberService,
    private authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any  {
    return this.memberService.getCompanyList(this.accessToken);
  }
}
